import { useState } from "react";
import { CATEGORIAS, getTipoCategoria } from '../constants/formConfig';
import { exportPDF, exportPDFAuditoria } from '../utils/pdfExport';
import { FiltroCategorias } from './FiltroCategorias';
import { GrupoMes } from './GrupoMes';

// ── ADMIN: ARCHIVO ───────────────────────────────────────────────
export const ArchivoSection = ({ archivo, currentUser, onEliminar }) => {
  const [filtroArchivo, setFiltroArchivo] = useState("Todas");
  const [busquedaArchivo, setBusquedaArchivo] = useState("");
  const [seleccionadosArchivo, setSeleccionadosArchivo] = useState(new Set());

  const archivoFiltrado = archivo.filter(r => (filtroArchivo === "Todas" || getTipoCategoria(r.tipo) === filtroArchivo) && (busquedaArchivo === "" || JSON.stringify(r).toLowerCase().includes(busquedaArchivo.toLowerCase())));
  const countsArchivo = CATEGORIAS.reduce((acc, cat) => {
    acc[cat] = cat === "Todas" ? archivo.length : archivo.filter(r => getTipoCategoria(r.tipo) === cat).length;
    return acc;
  }, {});

  return (
    <div className="space-y-3">
      <div className="flex items-center justify-between">
        <h2 className="font-bold text-gray-800">🗂️ Archivo — Validados</h2>
        <span className="text-xs text-gray-500">{archivoFiltrado.length} / {archivo.length} registros</span>
      </div>
      <FiltroCategorias filtro={filtroArchivo} setFiltro={setFiltroArchivo} counts={countsArchivo} />
      <div className="relative mt-2">
        <input
          type="text"
          placeholder="🔍 Buscar en registros..."
          value={busquedaArchivo}
          onChange={e => setBusquedaArchivo(e.target.value)}
          className="w-full border border-gray-200 rounded-xl px-4 py-2 text-sm text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-300"
        />
        {busquedaArchivo && (
          <button onClick={() => setBusquedaArchivo("")} className="absolute right-3 top-2 text-gray-400 hover:text-gray-600 text-sm">✕</button>
        )}
      </div>
      {archivoFiltrado.length === 0 && (
        <div className="bg-white rounded-xl shadow p-8 text-center text-gray-400">
          <p className="text-4xl mb-2">🗂️</p>
          <p className="text-sm">{filtroArchivo === "Todas" ? "No hay registros archivados aún." : `No hay registros de "${filtroArchivo}" en el archivo.`}</p>
        </div>
      )}
      {(() => {
        const grupos2 = {};
        archivoFiltrado.forEach(r => {
          const fecha = new Date(r.fecha.split("/").reverse().join("-"));
          const clave = `${fecha.getFullYear()}-${String(fecha.getMonth() + 1).padStart(2, "0")}`;
          const label = fecha.toLocaleDateString("es-ES", { month: "long", year: "numeric" });
          if (!grupos2[clave]) grupos2[clave] = { label, registros: [] };
          grupos2[clave].registros.push(r);
        });
        return Object.keys(grupos2)
          .sort((a, b) => b.localeCompare(a))
          .map(clave => (
            <GrupoMes
              key={clave}
              clave={clave}
              grupo={grupos2[clave]}
              onEliminar={onEliminar}
              onExport={exportPDF}
              seleccionados={seleccionadosArchivo}
              onToggleSeleccion={(id) => setSeleccionadosArchivo(prev => {
                const next = new Set(prev);
                next.has(id) ? next.delete(id) : next.add(id);
                return next;
              })}
            />
          ));
      })()}

      {/* Botón flotante auditoría */}
      {seleccionadosArchivo.size > 0 && (
        <div style={{ position: "fixed", bottom: 24, left: "50%", transform: "translateX(-50%)", zIndex: 40, display: "flex", gap: 10, alignItems: "center" }}>
          <div style={{ background: "white", borderRadius: 16, boxShadow: "0 8px 32px rgba(0,0,0,0.18)", padding: "12px 20px", display: "flex", gap: 10, alignItems: "center", border: "1px solid #e5e7eb" }}>
            <span style={{ fontSize: 13, fontWeight: 700, color: "#1e3a5f" }}>
              {seleccionadosArchivo.size} seleccionado{seleccionadosArchivo.size !== 1 ? "s" : ""}
            </span>
            <button
              onClick={() => {
                const regs = archivo.filter(r => seleccionadosArchivo.has(r.id));
                exportPDFAuditoria(regs, currentUser?.almacen_nombre);
              }}
              style={{ background: "linear-gradient(90deg,#1e3a5f,#0ea5e9)", color: "white", border: "none", borderRadius: 10, padding: "8px 18px", fontWeight: 700, fontSize: 13, cursor: "pointer" }}
            >
              📋 Exportar PDF auditoría
            </button>
            <button
              onClick={() => setSeleccionadosArchivo(new Set())}
              style={{ background: "#f3f4f6", color: "#6b7280", border: "none", borderRadius: 10, padding: "8px 12px", fontWeight: 700, fontSize: 12, cursor: "pointer" }}
            >
              ✕ Limpiar
            </button>
          </div>
        </div>
      )}
    </div>
  );
};
